import React from 'react'
import translator from '../translate'

import Profile from '../pages/profile'
import Pricing from 'src/pages/pricing'
import CustomDomain from 'src/pages/custom-domain'

import SendIcon from '@material-ui/icons/Dashboard'
import DashboardIcon from '@material-ui/icons/Dashboard'

import Cockpit from 'src/pages/cockpit'
import UseCoupon from 'src/pages/use-coupon'
import SubscriptionSuccess from 'src/pages/subscription_success'
import SubscriptionFailed from 'src/pages/subscription_failed'
import HelpCenter from 'src/pages/help-center'
import RefundCoupon from 'src/pages/cockpit/appsumo-refund-coupon'
import UserDetailedList from 'src/pages/cockpit/user-detailed-list'
import CreateCourseSelection from 'src/pages/create-course-selection'
import CreateCourse from 'src/pages/create-new-chat-deprecated'
import CreateCourseWithAi from 'src/pages/create-course-with-ai'
import MobileUI from 'src/pages/create-new-chat-deprecated/components/mobile-ui'
import MobileUiSelection from 'src/pages/create-course-selection/components/mobile-ui-selection'
import OtherProjects from 'src/pages/other-projects'
import Automations from 'src/pages/automations'
import UseTemplate from 'src/pages/use-template'
import { isMobileOnly } from 'react-device-detect'
import IntercomIntegration from 'src/pages/intercom-integration'
import CreateCourseWithAIUseDocs from 'src/pages/create-course-with-ai-use-docs'
import CourseEdit from 'src/pages/course-edit'
import CkEditorTest from 'src/pages/ck-editor-test'
import Collections from 'src/pages/collections'
import Collection from 'src/pages/collection'
import Courses from 'src/pages/courses'
import Home from 'src/pages/home'

const menus = [
  {
    label: 'Editor',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/ck-editor',
    link: '/ck-editor',
    pages: CkEditorTest,
    hidden: false,
    default: false,
  },
  {
    label: translator._('menu.profile'),
    icon: () => {
      return <SendIcon></SendIcon>
    },
    path: 'profile',
    link: '/profile',
    pages: Profile,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.createassignment'),
    icon: () => <DashboardIcon color="secondary" />,
    path: '/mini-course/:id/:page?/:subPage?',
    link: '/mini-course/:id/:page?/:subPage?',
    pages: CourseEdit,
    hidden: false,
    default: false,
  },
  {
    label: 'Create Course',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/create-course-selection',
    link: '/create-course-selection',
    pages: isMobileOnly ? MobileUiSelection : CreateCourseSelection,
    hidden: true,
    default: false,
  },
  {
    label: 'Create Course',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/create-course',
    link: '/create-course',
    pages: isMobileOnly ? MobileUI : CreateCourse,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/pricing',
    link: '/pricing',
    pages: Pricing,
    hidden: false,
    default: false,
  },
  {
    label: translator._('menu.customdomain'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/custom-domain',
    link: '/custom-domain',
    pages: CustomDomain,
    hidden: false,
    default: false,
  },

  {
    label: translator._('menu.cockpit'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/cockpit',
    link: '/cockpit',
    pages: Cockpit,
    hidden: false,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/use-coupon',
    link: '/use-coupon',
    pages: UseCoupon,
    hidden: true,
    default: false,
  },

  {
    label: translator._('menu.subscriptionsucces'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/subscription-successful',
    link: '/subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/starter-subscription-success-old',
    link: '/starter-subscription-success-old',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/quarterly-subscription-successful',
    link: '/quarterly-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },

  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/annual-starter-subscription-successful',
    link: '/annual-starter-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/starter-subscription-successful',
    link: '/starter-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/annual-premium-subscription-successful',
    link: '/annual-premium-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/premium-subscription-successful',
    link: '/premium-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/annual-premium-plus-subscription-successful',
    link: '/annual-premium-plus-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/premium-plus-subscription-successful',
    link: '/premium-plus-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/annual-pro-subscription-successful',
    link: '/annual-pro-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/pro-subscription-successful',
    link: '/pro-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },

  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/annual-elite-subscription-successful',
    link: '/annual-elite-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },
  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/elite-subscription-successful',
    link: '/elite-subscription-successful',
    pages: SubscriptionSuccess,
    hidden: true,
    default: false,
  },

  {
    label: translator._('menu.pricing'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/subscription-failed',
    link: '/subscription-failed',
    pages: SubscriptionFailed,
    hidden: true,
    default: false,
  },

  {
    label: translator._('menu.helpCenter'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/help-center',
    link: '/help-center',
    pages: HelpCenter,
    hidden: false,
    default: false,
  },
  {
    label: translator._('menu.refundPage'),
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/code-refund',
    link: '/code-refund',
    pages: RefundCoupon,
    hidden: false,
    default: false,
  },
  {
    label: 'User Roles',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/user-roles',
    link: '/user-roles',
    pages: UserDetailedList,
    hidden: false,
    default: false,
  },
  {
    label: 'Create Course With My Resource',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/create-course-with-ai-use-docs',
    link: '/create-course-with-ai-use-docs',
    pages: CreateCourseWithAIUseDocs,
    hidden: false,
    default: false,
  },
  {
    label: 'Create Course With Ai',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/create-course-with-ai',
    link: '/create-course-with-ai',
    pages: CreateCourseWithAi,
    hidden: false,
    default: false,
  },

  {
    label: 'Mobile UI',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/mobile-ui',
    link: '/mobile-ui',
    pages: MobileUI,
    hidden: false,
    default: false,
  },
  {
    label: 'Other Products',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/other-products',
    link: '/other-products',
    pages: OtherProjects,
    hidden: false,
    default: false,
  },

  {
    label: 'Automations',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/automations',
    link: '/automations',
    pages: Automations,
    hidden: false,
    default: false,
  },
  {
    label: 'Use Template',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/use-template/:courseCode*',
    link: '/use-template/:courseCode*',
    pages: UseTemplate,
    hidden: false,
    default: false,
  },
  {
    label: 'Intercom Redirect',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/intercom-integration',
    link: '/intercom-integration',
    pages: IntercomIntegration,
    hidden: false,
    default: false,
  },
  {
    label: 'Collections',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/collections',
    link: '/collections',
    pages: Collections,
    hidden: false,
    default: false,
  },
  {
    label: 'Collection',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/collection/:id?/:page?/:subPage?',
    link: '/collection/:id?/:page?/:subPage?',
    pages: Collection,
    hidden: false,
    default: false,
  },
  {
    label: 'Courses',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/courses',
    link: '/courses',
    pages: Courses,
    hidden: false,
    default: false,
  },
  {
    label: 'Mini Course Generator',
    icon: () => {
      return <DashboardIcon color="secondary"></DashboardIcon>
    },
    path: '/',
    link: '/',
    pages: Home,
    hidden: false,
    default: false,
  },
]

export default menus
